module.exports = __webpack_public_path__ + "static/media/SPENCER_SMYL.12dc846e.png";